module.exports = __webpack_public_path__ + "img/A58A0603.7ca70a07.jpg";